import React from "react";
import { NavLink } from "react-router-dom";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "../ui/tooltip";

export default function SidebarItem({ to, label, icon: Icon, end, collapsed }) {
  const content = (isActive) => (
    <div
      className={`flex items-center transition-all duration-200 hover:scale-[1.03] ${
        collapsed ? "justify-center w-10 h-10 rounded-xl" : "gap-2.5 px-3 py-2.5 w-full"
      }`}
    >
      <Icon
        className={`w-4 h-4 shrink-0 transition-all duration-200 ${
          isActive ? "text-white" : "text-gray-500 group-hover:text-gray-900"
        }`}
      />
      {!collapsed && (
        <span className="text-sm font-medium transition-opacity duration-200 whitespace-nowrap overflow-hidden text-ellipsis">
          {label}
        </span>
      )}
    </div>
  );

  const linkElement = (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `group flex items-center rounded-xl transition-all duration-200 ${
          collapsed ? "justify-center" : "w-full"
        } ${
          isActive
            ? "bg-gradient-to-r from-[#7C3AED] to-[#EC4899] text-white shadow-md shadow-[#7C3AED]/10 border border-[#7C3AED]/10"
            : "text-gray-600 hover:bg-gray-50 hover:text-gray-900 border border-transparent"
        }`
      }
      data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
    >
      {({ isActive }) => content(isActive)}
    </NavLink>
  );

  if (collapsed) {
    return (
      <TooltipProvider>
        <Tooltip delayDuration={50}>
          <TooltipTrigger asChild>
            {linkElement}
          </TooltipTrigger>
          <TooltipContent side="right" className="ml-2 bg-gray-900 text-white border border-gray-800 text-xs px-2.5 py-1.5 rounded-lg shadow-md font-medium">
            {label}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return linkElement;
}
